import { Component, OnInit, ViewChild} from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Http, Response } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

import { RRFormService } from '../r-r-form.service';


import 'rxjs/add/operator/map';
import swal from 'sweetalert2';


class signUpForm {
	username: string;
	role:string;
	branch:string; 
}

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;
	dtOptions: any = {};
	dtTrigger: Subject<any> = new Subject();

	signupform: signUpForm[] = [];

	signUpForm : FormGroup;
	private url = environment.url;
	response :any;

	rr_list :any = [];
		

	constructor( private http : Http, private router : Router, private rrService: RRFormService) { }

	ngOnInit() 
	{
		this.rrService.getAllPendingRR().subscribe(res=>{
			console.log(res);
			this.rr_list = res["data"];
		});
	}

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/dashboard/dashboard.component.ts